import { useCallback, useRef, useState, useEffect } from "react";
import { Space, Input, Select, Button, Modal } from "antd";
import "./index"
import {
  getMainModuleList,
  getChildModuleList
} from "../../../api/common";
import { getJobList, editJob } from "../../../api/departmentJob";
import { message } from "antd/lib";

const { TextArea } = Input;

const RoleEditForm = ({ isModalVisible, editModalHandleCancel, editdata, setData }) => {

  const [editingRecord, setEditingRecord] = useState(editdata);
  const [jobName, setJobName] = useState(editdata.job_name);
  const [paymentFrequency, setPaymentFrequency] = useState(editdata.payment_frequency);
  const [beanAmount, setBeanAmount] = useState(editdata.bean_amount);
  const [description, setDescription] = useState(editdata.description);
  // const [isModalOpen, setIsModalOpen] = useState(isModalVisible);
  console.log(editdata);
  // 主模块
  const [mainModuleData, setMainModuleData] = useState([]);
  const [defaultMainModuleKey, setDefaultMainModuleKey] = useState("");
  const [defaultMainModuleName, setDefaultMainModuleName] = useState("");

  // 子模块
  const [childModuleData, setChildModuleData] = useState([]);
  const [defaultChildModuleKey, setDefaultChildModuleKey] = useState("");
  const [defaultChildModuleName, setDefaultChildModuleName] = useState("");

  //角色名
  const onJobNameChanged = function (e) {
    setJobName(e.target.value);
    console.log(jobName);
  };
  //支付单位
  const onPaymentFrequencyChanged = function (id, option) {
    setPaymentFrequency(id);
  };

  //岗位标准
  const onbeanAmountChanged = useCallback((e) => {
    setBeanAmount(e.target.value);
    console.log(beanAmount);
  }, []);

  //岗位介绍
  const onDescriptionChanged = useCallback((e) => {
    setDescription(e.target.value);
  }, []);


  const updateJob = async function () {
    if (beanAmount == '' || defaultChildModuleKey == '0'
      || defaultChildModuleKey == '' || description == ''
      || jobName == '' || paymentFrequency === '' || paymentFrequency == -1) {
      message.error('资料先输完整哈');
      return;
    }

    const data = {
      bean_amount: beanAmount,
      department_id: defaultChildModuleKey,
      description: description,
      job_name: jobName,
      payment_frequency: paymentFrequency,
      role_id: editingRecord.job_id
    };
    //console.log(data);
  
    if (data.bean_amount <= 0 ) {
      message.error('智慧豆不能小于0');
      return;
    }
    const res = await editJob(data);

    //console.log(res);
    if (res.code == 0) {
      editModalHandleCancel();
      message.success('修改成功');
      //重新加载
      // let input = { page_no: 1, page_size: 10 };
      // let r = await getJobList(input);
      // setData(r.data.list);
      //console.log(editdata);
      editdata.bean_amount = beanAmount;
      editdata.description = description;
      editdata.payment_frequency = paymentFrequency;
      editdata.job_name = jobName;

      if (defaultMainModuleName != '') {
        editdata.main_depart_name = defaultMainModuleName;
      }
      if (defaultChildModuleName != '') {
        editdata.second_depart_name = defaultChildModuleName;
      }

    } else if (res.code == 555) {
      message.error('更新失败');
    }

  };
  // 获取主模块数据
  useEffect(() => {
    async function fetchMainModuleList() {
      console.log(editingRecord);
      const mainModuleList = [{ id: 0, name: "全部" }];
      const res = await getMainModuleList();
      if (res?.code == 0 && res?.data?.length > 0) {
        mainModuleList.push(...res.data);
      }
      setMainModuleData(mainModuleList);
      //setDefaultMainModuleKey(editingRecord.department_id);

      const newChildModuleData = [{ id: "0", name: "全部" }];
      const r = await getChildModuleList({ main_depart_id: editingRecord.parent_id });
      if (r.code == 0 && r.data?.length > 0) {
        newChildModuleData.push(...r.data);
      }
      console.log(r.data);
      if (editingRecord.parent_id == 11) {
        setDefaultMainModuleKey(9);
      } else {
        setDefaultMainModuleKey(editingRecord.parent_id);
      }

      setDefaultMainModuleName(editingRecord.main_depart_name);
      setChildModuleData(newChildModuleData);
      setDefaultChildModuleKey(editingRecord.department_id);

    }
    fetchMainModuleList();//初始化编辑状态的主板块,子板块数据
  }, []);

  // 选择主模块item
  const onMainModuleItemSelected = useCallback(async (id, option) => {
    const newChildModuleData = [{ id: "0", name: "全部" }];
    const newRoleData = [{ id: "0", name: "全部" }];
    if (id > "") {
      const res = await getChildModuleList({ main_depart_id: id });
      if (res.code == 0 && res.data?.length > 0) {
        newChildModuleData.push(...res.data);
      }
    }

    setDefaultMainModuleKey(id);
    setDefaultMainModuleName(option.name);
    setChildModuleData(newChildModuleData);
    setDefaultChildModuleKey(newChildModuleData[0].id);
  }, []);

  // 选择子模块
  const onChildModuleItemSelected = useCallback(async (id, option) => {
    //选择自然村的情况下加载自然村的数据
    setDefaultChildModuleKey(id);
    setDefaultChildModuleName(option.name);
  }, []);


  return <Modal
    title="编辑内容"
    open={isModalVisible}
    onOk={updateJob}
    onCancel={editModalHandleCancel}
    cancelText='取消'
    okText='确定'
    destroyOnClose={true}
  >
    <Space
      direction='vertical'
      align='start'
      size='middle'
    >
      <Space>
        <span className="leftTitle">请选择板块：</span>
        <Select
          value={defaultMainModuleKey}
          style={{ width: 180 }}
          fieldNames={{ label: "name", value: "id" }}
          onChange={onMainModuleItemSelected}
          options={mainModuleData}
        />
      </Space>
      <Space>
        <span className="leftTitle">选择子板块：</span>
        <Select
          value={defaultChildModuleKey}
          style={{ width: 180 }}
          fieldNames={{ label: "name", value: "id" }}
          onChange={onChildModuleItemSelected}
          options={childModuleData}
        />
      </Space>
      <Space>
        <span className="leftTitle">创建任务角色：</span>
        <Input
          style={{
            width: 200,
          }}
          onChange={onJobNameChanged}
          placeholder="请输入角色名称"
          value={jobName}
        />
      </Space>
      <Space>
        <span className="leftTitle">标准智慧豆：</span>
        <Input
          style={{
            width: 160,
          }}
          placeholder="请输入智慧豆"
          onChange={onbeanAmountChanged}
          value={beanAmount}
        />
        <Select
          style={{
            width: 100,
          }}
          placeholder="选择单位"
          onChange={onPaymentFrequencyChanged}
          options={[{ id: -1, name: '请选择' }, { id: 0, name: '次' }, { id: 1, name: '月' }]}
          fieldNames={{ label: "name", value: "id" }}
          value={paymentFrequency}
        />
      </Space>
      <Space>
        <span className="leftTitle">岗位介绍：</span>
        <TextArea
          className="postInfo"
          placeholder="请输入岗位信息"
          autoSize={{
            minRows: 6,
            maxRows: 6,
          }}
          style={{ width: 270, }}
          onChange={onDescriptionChanged}
          value={description}
        />
      </Space>
    </Space>
  </Modal>
}

export default RoleEditForm;
